import { useContext } from "react";
import {
  ContainerSwitchTheme,
  Input,
  Slider,
  SliderRound,
  Switch,
} from "../menu/style";
import { ContainerLayout } from "./styled";
import { ThemeContext } from "../../Provider/ThemeProvider";

export default function Header({
  title,
  onOpen,
}: {
  title?: string;
  onOpen: VoidFunction;
}) {
  const { selectTheme } = useContext<any>(ThemeContext);
  const { alterTheme } = useContext(ThemeContext);

  function SwitchTheme() {
    localStorage.setItem(
      "theme",
      selectTheme?.name == "dark" ? "dark" : "light"
    );
    if (alterTheme) {
      alterTheme();
    }
  }

  return (
    <ContainerLayout>
      <div style={{ position: 'absolute', right: 2, top: 8 }}>
      <ContainerSwitchTheme>
        <Switch>
          <Input type="checkbox" />
          <SliderRound />
        </Switch>
        <Switch>
          <Input
            type="checkbox"
            onClick={SwitchTheme}
            checked={selectTheme?.name == "dark"}
          />
          <Slider />
        </Switch>
      </ContainerSwitchTheme>
      </div>
    </ContainerLayout>
  );
}
